module.exports = new __parcel__URL__("future-nostalgia.e13c167e.jpg").toString();